// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://basescan.org/address/0xe20fCBdBfFC4Dd138cE8b2E6FBb6CB49777ad64D
export const POOL_ADDRESSES_PROVIDER = '0xe20fCBdBfFC4Dd138cE8b2E6FBb6CB49777ad64D';

// IPool https://basescan.org/address/0xA238Dd80C259a72e81d7e4664a9801593F98d1c5
export const POOL = '0xA238Dd80C259a72e81d7e4664a9801593F98d1c5';

// IPoolConfigurator https://basescan.org/address/0x5731a04B1E775f0fdd454Bf70f3335886e9A96be
export const POOL_CONFIGURATOR = '0x5731a04B1E775f0fdd454Bf70f3335886e9A96be';

// IAaveOracle https://basescan.org/address/0x2Cc0Fc26eD4563A5ce5e8bdcfe1A2878676Ae156
export const ORACLE = '0x2Cc0Fc26eD4563A5ce5e8bdcfe1A2878676Ae156';

// https://basescan.org/address/0x943AcD0c93d7a8Bee7dA5Fd0DC3d0028237074d6
export const PRICE_ORACLE_SENTINEL = '0x943AcD0c93d7a8Bee7dA5Fd0DC3d0028237074d6';

// https://basescan.org/address/0x9390B1735def18560c509E2d0bc090E9d6BA257a
export const ACL_ADMIN = '0x9390B1735def18560c509E2d0bc090E9d6BA257a';

// IACLManager https://basescan.org/address/0x43955b0899Ab7232E3a454cf84AedD22Ad46FD33
export const ACL_MANAGER = '0x43955b0899Ab7232E3a454cf84AedD22Ad46FD33';

// IPoolDataProvider https://basescan.org/address/0x0F43731EB8d45A581f4a36DD74F5f358bc90C73A
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x0F43731EB8d45A581f4a36DD74F5f358bc90C73A';

// https://basescan.org/address/0xDb578D67A83E94DE73c9e0C14280f804F6C1c3e4
export const POOL_IMPL = '0xDb578D67A83E94DE73c9e0C14280f804F6C1c3e4';

// https://basescan.org/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://basescan.org/address/0xf9cc4F0D883F1a1eb2c253bdb46c254Ca51E1F44
export const DEFAULT_INCENTIVES_CONTROLLER = '0xf9cc4F0D883F1a1eb2c253bdb46c254Ca51E1F44';

// https://basescan.org/address/0x6533A273F3aC84Df91DCD654D6EBAbA73687e246
export const EMISSION_MANAGER = '0x6533A273F3aC84Df91DCD654D6EBAbA73687e246';

// ICollector https://basescan.org/address/0xBA9424d650A4F5c80a0dA641254d1AcCE2A37057
export const COLLECTOR = '0xBA9424d650A4F5c80a0dA641254d1AcCE2A37057';

// https://basescan.org/address/0x273E4B97C3f5280AFf4949Aa19a27fF54968458D
export const DEFAULT_A_TOKEN_IMPL = '0x273E4B97C3f5280AFf4949Aa19a27fF54968458D';

// https://basescan.org/address/0x7354Dc700A1A2ab9622f2292B60Ca1ceD5B204D0
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x7354Dc700A1A2ab9622f2292B60Ca1ceD5B204D0';

// https://basescan.org/address/0x085E34722e04567Df9E6d2c32e82fd74f3342e79
export const RISK_STEWARD = '0x085E34722e04567Df9E6d2c32e82fd74f3342e79';

// https://basescan.org/address/0xB892202d9Ce2C16C565A492a5168689b215Eb269
export const EDGE_RISK_STEWARD_CAPS = '0xB892202d9Ce2C16C565A492a5168689b215Eb269';

// https://basescan.org/address/0x4f84A364B66Eb6280350da011829a6BD02B4712f
export const EDGE_INJECTOR_CAPS = '0x4f84A364B66Eb6280350da011829a6BD02B4712f';

// https://basescan.org/address/0x239d3Bc5fa247337287cb03f53B8bc63DBBc332D
export const EDGE_RISK_ORACLE = '0x239d3Bc5fa247337287cb03f53B8bc63DBBc332D';

// https://basescan.org/address/0xb12e82DF057BF16ecFa89D7D089dc7E5C1Dc057B
export const DEBT_SWAP_ADAPTER = '0xb12e82DF057BF16ecFa89D7D089dc7E5C1Dc057B';

// https://basescan.org/address/0x5598BbFA2f4fE8151f45bBA0a3edE1b54B51a0a9
export const WITHDRAW_SWAP_ADAPTER = '0x5598BbFA2f4fE8151f45bBA0a3edE1b54B51a0a9';

// https://basescan.org/address/0x2E549104c516b8657A7D888494DfbAbD7C70b464
export const SWAP_COLLATERAL_ADAPTER = '0x2E549104c516b8657A7D888494DfbAbD7C70b464';

// https://basescan.org/address/0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4';

// https://basescan.org/address/0x940F9a5d5F9ED264990D0eaee1F3DD60B4Cb9A22
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x940F9a5d5F9ED264990D0eaee1F3DD60B4Cb9A22';

// https://basescan.org/address/0xe63eAf6DAb1045689BD3a332bC596FfcF54A5C88
export const LEGACY_STATIC_A_TOKEN_ORACLE = '0xe63eAf6DAb1045689BD3a332bC596FfcF54A5C88';

// https://basescan.org/address/0x98436999cA3bE615681062fE0a228f2CEC352DF7
export const CONFIG_ENGINE = '0x98436999cA3bE615681062fE0a228f2CEC352DF7';

// https://basescan.org/address/0x39e97c588B2907Fb67F44fea256Ae3BA064207C5
export const L2_ENCODER = '0x39e97c588B2907Fb67F44fea256Ae3BA064207C5';

// https://basescan.org/address/0x2f6571d3Eb9a4e350C68C36bCD2afe39530078E2
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x2f6571d3Eb9a4e350C68C36bCD2afe39530078E2';

// https://basescan.org/address/0x91E04cf78e53aEBe609e8a7f2003e7EECD743F2B
export const UI_INCENTIVE_DATA_PROVIDER = '0x91E04cf78e53aEBe609e8a7f2003e7EECD743F2B';

// https://basescan.org/address/0xb84A20e848baE3e13897934bB4e74E2225f4546B
export const UI_POOL_DATA_PROVIDER = '0xb84A20e848baE3e13897934bB4e74E2225f4546B';

// https://basescan.org/address/0x5779b29B0a34577d927E8D511B595ef9abbFAE82
export const WALLET_BALANCE_PROVIDER = '0x5779b29B0a34577d927E8D511B595ef9abbFAE82';

// https://basescan.org/address/0xa0d9C1E9E48Ca30c8d8C3B5D69FF5dc1f6DFfC24
export const WETH_GATEWAY = '0xa0d9C1E9E48Ca30c8d8C3B5D69FF5dc1f6DFfC24';

// https://basescan.org/address/0x78d33BF0014ab169725F2Ea5a62b200F2977faeE
export const STATA_FACTORY = '0x78d33BF0014ab169725F2Ea5a62b200F2977faeE';

// https://basescan.org/address/0x3870D459d2fC2Edbb03E0DdeE6c0Ccb268caf202
export const DUST_BIN = '0x3870D459d2fC2Edbb03E0DdeE6c0Ccb268caf202';

// https://basescan.org/address/0x1a79098C3149020ACdEfb3EE44AA1d9509305530
export const CLINIC_STEWARD = '0x1a79098C3149020ACdEfb3EE44AA1d9509305530';

// https://basescan.org/address/0x4f1F3E32f20847a4c9F002882eB607aD750b6115
export const POOL_EXPOSURE_STEWARD = '0x4f1F3E32f20847a4c9F002882eB607aD750b6115';

export const CHAIN_ID = 8453;
export const ASSETS = {
  WETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x4200000000000000000000000000000000000006',
    A_TOKEN: '0xD4a0e0b9149BCee3C920d2E00b5dE09138fd8bb7',
    V_TOKEN: '0x24e6e0795b3c7c71D965fCc4f371803d1c1DcA1E',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70',
    STATIC_A_TOKEN: '0x468973e3264F2aEba0417A8f2cD0Ec397E738898',
    STATA_TOKEN: '0xe298b938631f750DD409fB18227C4a23dCdaab9b',
  },
  cbETH: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22',
    A_TOKEN: '0xcf3D55c10DB69f28fD1A75Bd73f3D8A2d9c595ad',
    V_TOKEN: '0x1DabC36f19909425f654777249815c073E8Fd79F',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x8e11Ad4531826ff47BD8157a2c705F5422Da6A61',
    STATIC_A_TOKEN: '0x16A004065dfb11276DcB29Dc03fb8A85f9A43C6e',
    STATA_TOKEN: '0x5e8B674127B321DC344c078e58BBACc3f3008962',
  },
  USDbC: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA',
    A_TOKEN: '0x0a1d576f3eFeF75b330424287a95A366e8281D54',
    V_TOKEN: '0x7376b2F323dC56fCd4C191B34163ac8a84702DAB',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xfcF82bFa2485253263969167583Ea4de09e9993b',
    STATIC_A_TOKEN: '0x6fCe2756794128B1771324caA860965801DCbCdB',
    STATA_TOKEN: '0x74D4D1D440c9679b1013999Bd91507eAa2fff651',
  },
  wstETH: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452',
    A_TOKEN: '0x99CBC45ea5bb7eF3a5BC08FB1B7E56bB2442Ef0D',
    V_TOKEN: '0x41A7C3f5904ad176dACbb1D99101F59ef0811DC1',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x56038D3998C42db18ba3B821bD1EbaB9B678e657',
    STATIC_A_TOKEN: '0x03916e49f794Ab877eFA23597627eE8094E6cbB0',
    STATA_TOKEN: '0x0830820D1A9aa1554364752d6D8F55C836871B74',
  },
  USDC: {
    decimals: 6,
    id: 4,
    UNDERLYING: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    A_TOKEN: '0x4e65fE4DbA92790696d040ac24Aa414708F5c0AB',
    V_TOKEN: '0x59dca05b6c26dbd64b5381374aAaC5CD05644C28',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xfcF82bFa2485253263969167583Ea4de09e9993b',
    STATIC_A_TOKEN: '0x4EA71A20e655794051D1eE8b6e4A3269B13ccaCc',
    STATA_TOKEN: '0xC768c589647798a6EE01A91FdE98EF2ed046DBD6',
  },
  weETH: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A',
    A_TOKEN: '0x7C307e128efA31F540F2E2d976C995E0B65F51F6',
    V_TOKEN: '0x8D2e3F1f4b38AA9f1ceD22ac06019c7561B03901',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xFc4d1d7a8FD1E6719e361e16044b460737F12C44',
    STATIC_A_TOKEN: '0x588159E0d360ffAA978330812f9234818ab46E8E',
    STATA_TOKEN: '0x6acD0a165fD70A84b6b50d955ff3628700bAAf4b',
  },
  cbBTC: {
    decimals: 8,
    id: 6,
    UNDERLYING: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
    A_TOKEN: '0xBdb9300b7CDE636d9cD4AFF00f6F009fFBBc8EE6',
    V_TOKEN: '0x05e08702028de6AaD395DC6478b554a56920b9AD',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x64c911996D3c6aC71f9b455B1E8E7266BcbD848F',
    STATIC_A_TOKEN: '0xeaCFa728623d0958e3C386bACed79138BCAfC50F',
    STATA_TOKEN: '0xFA2A03b6f4A65fB1Af64f7d935fDBf78693df9aF',
  },
  ezETH: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0x2416092f143378750bb29b79eD961ab195CcEea5',
    A_TOKEN: '0xDD5745756C2de109183c6B5bB886F9207bEF114D',
    V_TOKEN: '0xbc4f5631f2843488792e4F1660d0A51Ba489bdBd',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x438e24f5FCDC1A66ecb25D19B5543e0Cb91A44D4',
    STATA_TOKEN: '0xF8F10f39116716e89498c1c5E94137ADa11b2BC7',
  },
  GHO: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee',
    A_TOKEN: '0x067ae75628177FD257c2B1e500993e1a0baBcBd1',
    V_TOKEN: '0x38e59ADE183BbEb94583d44213c8f3297e9933e9',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73',
    STATA_TOKEN: '0x88b1Cd4b430D95b406E382C3cDBaE54697a0286E',
  },
  wrsETH: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0xEDfa23602D0EC14714057867A78d01e94176BEA0',
    A_TOKEN: '0x80a94C36747CF51b2FbabDfF045f6D22c1930eD1',
    V_TOKEN: '0xe9541C77a111bCAa5dF56839bbC50894eba7aFcb',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x567E7f3DB2CD4C81872F829C8ab6556616818580',
    STATA_TOKEN: '0xCa79190050739D27B61e24B085DD4Af990254Ec2',
  },
  LBTC: {
    decimals: 8,
    id: 10,
    UNDERLYING: '0xecAc9C5F704e954931349Da37F60E39f515c11c1',
    A_TOKEN: '0x90072A4aA69B5Eb74984Ab823EFC5f91e90b3a72',
    V_TOKEN: '0xa2525b3f058846075506903d792d58C5a0D834c9',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xA04669FE5cba4Bb21f265B562D23e562E45A1C67',
  },
  EURC: {
    decimals: 6,
    id: 11,
    UNDERLYING: '0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42',
    A_TOKEN: '0x90DA57E0A6C0d166Bf15764E03b83745Dc90025B',
    V_TOKEN: '0x03D01595769333174036832e18fA2f17C74f8161',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x215f25556f91b30AFCF0a12dA51C9d4374B22570',
    STATA_TOKEN: '0x729F75Aff28c726e32403e80cef2aFb518CFbfa7',
  },
  AAVE: {
    decimals: 18,
    id: 12,
    UNDERLYING: '0x63706e401c06ac8513145b7687A14804d17f814b',
    A_TOKEN: '0x67EAF2BeE4384a2f84Da9Eb8105C661C123736BA',
    V_TOKEN: '0xcEC1Ea95dDEF7CFC27D3D9615E05b035af460978',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x3d6774EF702A10b20FCa8Ed40FC022f7E4938e07',
    STATA_TOKEN: '0x4170aa42631d60160171C60d523A2783565261b9',
  },
  tBTC: {
    decimals: 18,
    id: 13,
    UNDERLYING: '0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b',
    A_TOKEN: '0xbcFFB4B3beADc989Bd1458740952aF6EC8fBE431',
    V_TOKEN: '0x182cDEEC1D52ccad869d621bA422F449FA5809f5',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0x64c911996D3c6aC71f9b455B1E8E7266BcbD848F',
  },
  syrupUSDC: {
    decimals: 6,
    id: 14,
    UNDERLYING: '0x660975730059246A68521a3e2FBD4740173100f5',
    A_TOKEN: '0xD7424238CcbE7b7198Ab3cFE232e0271E22da7bd',
    V_TOKEN: '0x57B8C05ee2cD9d0143eBC21FBD9288C39B9F716c',
    INTEREST_RATE_STRATEGY: '0x86AB1C62A8bf868E1b3E1ab87d587Aba6fbCbDC5',
    ORACLE: '0xa61f10Bb2f05A94728734A8a95673ADbCA9B8397',
    STATA_TOKEN: '0xaD785bd1666c582FcAb74088ce73BDF4c9da1f20',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'WETH,cbETH,wstETH,weETH / WETH',
    collateralBitmap: '43',
    collateralAssets: [
      '0x4200000000000000000000000000000000000006',
      '0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22',
      '0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452',
      '0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A',
    ],
    borrowableBitmap: '1',
    borrowableAssets: ['0x4200000000000000000000000000000000000006'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '2': {
    label: 'ezETH / wstETH',
    collateralBitmap: '128',
    collateralAssets: ['0x2416092f143378750bb29b79eD961ab195CcEea5'],
    borrowableBitmap: '8',
    borrowableAssets: ['0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '3': {
    label: 'ezETH / USDC',
    collateralBitmap: '128',
    collateralAssets: ['0x2416092f143378750bb29b79eD961ab195CcEea5'],
    borrowableBitmap: '16',
    borrowableAssets: ['0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7200,
    liquidationThreshold: 7500,
    liquidationBonus: 10750,
  },
  '4': {
    label: 'LBTC / cbBTC',
    collateralBitmap: '1024',
    collateralAssets: ['0xecAc9C5F704e954931349Da37F60E39f515c11c1'],
    borrowableBitmap: '64',
    borrowableAssets: ['0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8200,
    liquidationThreshold: 8400,
    liquidationBonus: 10300,
  },
  '5': {
    label: 'wrsETH / WETH,wstETH',
    collateralBitmap: '512',
    collateralAssets: ['0xEDfa23602D0EC14714057867A78d01e94176BEA0'],
    borrowableBitmap: '9',
    borrowableAssets: [
      '0x4200000000000000000000000000000000000006',
      '0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '6': {
    label: 'wrsETH / USDC',
    collateralBitmap: '512',
    collateralAssets: ['0xEDfa23602D0EC14714057867A78d01e94176BEA0'],
    borrowableBitmap: '16',
    borrowableAssets: ['0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7200,
    liquidationThreshold: 7500,
    liquidationBonus: 10750,
  },
  '7': {
    label: 'weETH / WETH',
    collateralBitmap: '32',
    collateralAssets: ['0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x4200000000000000000000000000000000000006'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10125,
  },
  '8': {
    label: 'wstETH / WETH',
    collateralBitmap: '8',
    collateralAssets: ['0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x4200000000000000000000000000000000000006'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '9': {
    label: 'cbETH / WETH',
    collateralBitmap: '2',
    collateralAssets: ['0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x4200000000000000000000000000000000000006'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10200,
  },
  '10': {
    label: 'cbBTC / USDC,GHO',
    collateralBitmap: '64',
    collateralAssets: ['0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf'],
    borrowableBitmap: '272',
    borrowableAssets: [
      '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
      '0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8000,
    liquidationThreshold: 8300,
    liquidationBonus: 10400,
  },
  '11': {
    label: 'syrupUSDC / USDC,GHO',
    collateralBitmap: '16384',
    collateralAssets: ['0x660975730059246A68521a3e2FBD4740173100f5'],
    borrowableBitmap: '272',
    borrowableAssets: [
      '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
      '0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10400,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
